var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-detail"
  }, [_c('el-card', {
    directives: [{
      name: "watermark",
      rawName: "v-watermark",
      value: ('in'),
      expression: "'in'"
    }],
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('h4', [_vm._v("订单信息")]), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("订单编号：" + _vm._s(_vm.info.paxJourneyGuid))]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("创建时间：" + _vm._s(_vm.info.createTimeName))]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("订单状态：" + _vm._s(_vm.info.paxOrderStatus))])], 1), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("上车时间：" + _vm._s(_vm.info.aboardTimeName))]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("出发经度：" + _vm._s(_vm.info.origin.location.lon))]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("出发纬度：" + _vm._s(_vm.info.origin.location.lat))])], 1), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("出发省份：" + _vm._s(_vm.info.origin.provinceName))]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("出发城市：" + _vm._s(_vm.info.origin.cityName))]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('span', [_vm._v("出发地址：")]), _c('el-tooltip', {
    attrs: {
      "content": _vm.info.origin.longAddr,
      "placement": "top"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.info.origin.shortAddr))])])], 1)], 1), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("到达时间：" + _vm._s(_vm.info.arriveTimeName))]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("终点经度：" + _vm._s(_vm.info.destination.location.lon))]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("终点纬度：" + _vm._s(_vm.info.destination.location.lat))])], 1), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("终点省份：" + _vm._s(_vm.info.destination.provinceName))]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("终点城市：" + _vm._s(_vm.info.destination.cityName))]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('span', [_vm._v("终点地址：")]), _c('el-tooltip', {
    attrs: {
      "content": _vm.info.destination.longAddr,
      "placement": "top"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.info.destination.shortAddr))])])], 1)], 1), _c('hr'), _c('h4', [_vm._v("乘客信息")]), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("姓名：" + _vm._s(_vm.info.passengerInfo.userName))]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("手机号：" + _vm._s(_vm.info.passengerInfo.mobile))]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("身份证号：" + _vm._s(_vm.info.passengerInfo.idCard))])], 1), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("性别：" + _vm._s(_vm._f("gender")(_vm.info.passengerInfo.gender)))])], 1), _c('hr'), _c('h4', [_vm._v("车主信息")]), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("姓名：" + _vm._s(_vm.info.driverInfo.userName))]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("手机号：" + _vm._s(_vm.info.driverInfo.mobile))]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("身份证号：" + _vm._s(_vm.info.driverInfo.idCard))])], 1), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("性别：" + _vm._s(_vm._f("gender")(_vm.info.driverInfo.gender)))])], 1), _c('hr'), _c('h4', [_vm._v("车辆信息")]), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("车辆名称和型号：" + _vm._s(_vm.info.carType))]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("车辆颜色：" + _vm._s(_vm.info.carColor))]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("车牌号：" + _vm._s(_vm.info.plateNumber))])], 1), _c('hr'), _c('h4', [_vm._v("同行乘客")]), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("是否拼车：" + _vm._s(_vm.info.poolStatus))]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("乘客人数：" + _vm._s(_vm.info.passengerCount))])], 1), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.info.sameJourneyList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "passengerInfo.userName",
      "label": "乘客姓名"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "passengerInfo.mobile",
      "label": "手机号"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "passengerInfo.idCard",
      "label": "身份证号"
    }
  }), _c('el-table-column', {
    attrs: {
      "label": "订单编号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "text-decoration": "underline"
          },
          attrs: {
            "href": ("/#/order/hitch/detail?guid=" + (scope.row.paxJourneyGuid)),
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(scope.row.paxJourneyGuid))])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6758f760", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6758f760","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/hitch/detail.vue
// module id = n/vE
// module chunks = 1